import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {googleMapLoader, googleMapStyleDark, googleMapStyleLight} from '@mri/constants';
import { GlobalMapService } from './global-map.service';
import { delay, Subscription, tap } from 'rxjs';
import { AnyObject } from '@mri/types';
import { ThemeProConfig } from '../../app-config';

type GMap = google.maps.Map;

@Component({
  selector: 'app-global-map',
  template: `
      <div #mapContainer class="map-container w-full h-full">
          <div class="fixed h-full w-full " [style.width]="width + 'px'">
              <div #mapContent id="mapContent" class="h-full w-full bg-info" [style.opacity]="visible ? 1: 0">

              </div>
          </div>

        @if (!visible) {
          <div class="fixed h-full w-full" style="background: transparent"></div>
        }
      
      </div>
  `,
  styles: [`
    #mapContent{
      transition: all 400ms;
    }
  `]
})
export class GlobalMapComponent implements OnInit, OnDestroy {


  private _subscription = new Subscription();
  private _mapObject!: GMap;

  width: number;
  visible!: boolean;

  @ViewChild('mapContent') mapContent: ElementRef;
  @ViewChild('mapContainer') mapContainer: ElementRef;

  constructor(
    private _globalMapSrv: GlobalMapService
  ) {

  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
  }

  ngOnInit(): void {
    this.visible = this._globalMapSrv.visible;

    this._subscription.add(
      this._globalMapSrv.visible$
        .pipe(
          tap(visible => this.visible = visible),
        )
        .subscribe()
    );

    this._observerSizeContainer();

    this._renderMap();
  }

  private _observerSizeContainer() {
    setTimeout(() => {
      const container = document.querySelector('.map-container');
      if (!container) return;
      new ResizeObserver(() => {
        this.width = container.clientWidth;
      }).observe(container);
    }, 500)

  }


  private _renderMap() {
    googleMapLoader
      .load()
      .then(google => this._mapInit(google));
  }

  private _mapInit(google: AnyObject): void {
    const element = document.getElementById('mapContent');

    if (!element) return console.error('Element "mapContent not fount" in component');

    const mapOptions: google.maps.MapOptions = {
      center: {
        lat: 10.382557,
        lng: -75.506496
      },
      zoom: 16,
      zoomControl: false,
      mapTypeControl: false,
      streetViewControl: true,
      fullscreenControl: false,
      styles: ThemeProConfig.layout_type === 'light-mode' ? googleMapStyleLight: googleMapStyleDark
    };

    this._mapObject = new google.maps.Map(element, mapOptions);

    this._globalMapSrv.map = this._mapObject;

  }



}
